import React, {Component, useState} from 'react';
import {Link, Route, Routes} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faBuilding, faBars } from '@fortawesome/free-solid-svg-icons'
import { faPlug } from '@fortawesome/free-solid-svg-icons'
import { faSolarPanel } from '@fortawesome/free-solid-svg-icons'
import NavContent from './NavContent';
import { faBatteryFull, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'





export default function Header({ isSidebarOpen }){
    


        
        return (
             <div>
                
    {isSidebarOpen ? <NavContent /> : ""}
                    
            </div>
            
         
        )
    }






  